import { render } from "./EntityIndustrySelector.vue?vue&type=template&id=47beec40"
import script from "./EntityIndustrySelector.vue?vue&type=script&lang=js"
export * from "./EntityIndustrySelector.vue?vue&type=script&lang=js"
script.render = render

export default script